// # #############################################
// # Title : Filter Table
// # Authors : Dhruv
// # Date : 15th October 2019
// # Last Modified : September 2019
// # Version : 19.10.03
// # Description : Code for the table component in open scenario tab
// # ############################################

//Note: Promotional spend has been commented from the table 


import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from "prop-types";
import SearchIcon from '@material-ui/icons/Search';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button'
import InputBase from '@material-ui/core/InputBase';
import TablePagination from '@material-ui/core/TablePagination';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import Tooltip from '@material-ui/core/Tooltip';

// import CloseIcon from '@material-ui/icons/Close';
// import IconButton from '@material-ui/core/IconButton';


import '../css/OpenScenarioDialogue.css';
import { MenuItem } from '@material-ui/core';

const StyledButton2 = withStyles(theme => ({

    root: {
        width: "calc(2vw + 2vh)",
        minWidth: 0,
        padding: '0px',
        background: 'white',

        border: '1px solid #d3d3d3',
        borderRadius: '3px',

        "&:hover": {
            border: '1px solid #44BDCD',
            background: 'white'
        }
    },

    label: {
        justifyContent: 'center'
    },

    text: {

        textAlign: 'left',
        fontFamily: 'Roboto',
        fontWeight: '400',
        color: '#ababab',
        fontSize: 'calc(0.75vh + 0.4vw )',
        verticalAlign: 'sub',
        "&:hover": {
            color: '#42BCCD',

        }


    },

}))(Button)


const StyledTablePagination = withStyles(theme => ({
    root: {
        fontSize: 'calc(0.75vh + 0.4vw )'
    },

    menuItem: {
        fontSize: 'calc(0.75vh + 0.4vw )',
        width: 'calc(1vw + 5vh)',
        height: 'calc(0.5vw + 0.5vh)',
    },

    spacer: {
        fontSize: 'calc(0.75vh + 0.4vw )',
    },

    caption: {
        fontSize: 'calc(0.75vh + 0.4vw )',
    },

    selectRoot: {
        fontSize: 'calc(0.75vh + 0.4vw )',
    },
    select: {
        fontSize: 'calc(0.75vh + 0.4vw )',
        width: '28px'
    },

    toolbar: {

        fontSize: 'calc(0.75vh + 0.4vw )',
        minHeight: 0,
        height: '4vh',
        [theme.breakpoints.down('sm')]: {
            padding: '0px 2px 0px 2px',
        },
    },

    selectIcon: {
        maxWidth: 'calc(1vh + 1vw)'
    },


    input: {
        fontSize: 'calc(0.75vh + 0.4vw )',
        width: '68px',
        [theme.breakpoints.down('sm')]: {
            width: '50px'
        },
    },

    actions: {
        [theme.breakpoints.down('sm')]: {
            marginLeft: '5px'
        },
    }

}))(TablePagination);

const StyledToggleButton = withStyles(theme => ({
    root: {
        minWidth: "0px",
        width: '50px',
        borderRadius: '0px',
        padding: '6px',
        boxShadow: '0px'
    },

    [theme.breakpoints.down('sm')]: {
        root: {
            maxWidth: 'calc(17px + 1vh)',
            maxHeight: 'calc(17px + 1vh)'
        }
    },
}))(ToggleButton)

const StyledTooltip = withStyles(theme => ({
    tooltip: {
        display: 'flex',
        textAlign: "center",
        justifyContent: 'center',
        alignItems: 'center',
        height: '30px',
        width: '40px'
    }
}))(Tooltip)

const StyledMenuProd = withStyles(theme => ({
    root: {
        width: 'calc(1vw + 5vh)',
        height: 'calc(0.5vw + 0.5vh)',
        fontSize: 'calc(0.75vh + 0.4vw )'
    }
}))(MenuItem)

const StyledMenuSort = withStyles(theme => ({
    root: {
        width: "calc(3vw + 12vh)",
        height: 'calc(0.5vw + 0.5vh)',
        fontSize: 'calc(0.75vh + 0.4vw )'
    }
}))(MenuItem)


const StyledProductSelect = withStyles(theme => ({
    root: {
        width: 'calc(3vw + 5vh)'
    },


    icon: {
        color: '6ECBD9'
    },

    select: {
        textAlign: 'left',
        color: "#3aa7bd",
        fontWeight: '500',
        fontSize: 'calc(0.75vh + 0.4vw )'
    },

    [theme.breakpoints.down('sm')]: {

    },
}))(Select)

const StyledSortSelect = withStyles(theme => ({
    root: {
        width: 'calc(3vw + 12vh)'
    },



    icon: {
        color: '6ECBD9'
    },

    select: {
        textAlign: 'left',
        color: "#3aa7bd",
        fontWeight: '500',
        fontSize: 'calc(0.75vh + 0.4vw )'
    },

    [theme.breakpoints.down('sm')]: {

    },
}))(Select)


const StyledButton = withStyles(theme => ({
    root: {
        minWidth: "0px",
        marginRight: '5px',
        borderRadius: '0px',
        padding: '6px',
        boxShadow: '0px'
    },

    "&:hover": {
        backgroundColor: "white !important"
    },

    [theme.breakpoints.down('sm')]: {
        root: {
            maxWidth: 'calc(17px - 0.5vh)',
            maxHeight: 'calc(17px - 0.5vh)'
        }
    },
}))(Button)

const StyledInputBase = withStyles(theme => ({
    color: '#989898',
    fontStyle: 'italic',
    input: {
        [theme.breakpoints.down('md')]: {
            fontSize: 'calc(4px + 0.5vh + 0.5vw)',
            padding: 'calc( 4px + .1vw + .1vh) 0'
        },
    }

}))(InputBase)

const styles = theme => ({
    root: {
        width: '100%',
    },

    tableWrapper: {
        maxHeight: '50vh',
        overflow: 'auto',
        [theme.breakpoints.up('sm')]: {
            marginTop: '0px'
        },
        [theme.breakpoints.down('sm')]: {
            marginTop: '10px'
        },
    },

    productIcon: {
        minWidth: "0px",
        marginRight: '5px',
        borderRadius: '0px',
        padding: '6px',
        boxShadow: '0px',

        [theme.breakpoints.down('sm')]: {

            maxWidth: 'calc(17px - 0.5vh)',
            maxHeight: 'calc(17px - 0.5vh)'

        },
    },

    tableCell: {

        borderBottom: "1px solid #CFCFCF80",

        [theme.breakpoints.down('xl')]: {
            padding: '2px calc(40px - 1vw) 2px 10px',

        },

        [theme.breakpoints.down('md')]: {
            padding: '2px calc(20px - 1vw) 2px 10px',

        },

        [theme.breakpoints.down('sm')]: {
            padding: '2px calc(0.2vw + 0.2vh) 2px calc(0.2vh + 0.2vh)',

        },

    },

    info: {

        [theme.breakpoints.down('xl')]: {
            padding: '2px calc(40px - 1vw) 2px 10px',

        },

        [theme.breakpoints.down('md')]: {
            padding: '2px calc(20px - 1vw) 2px 10px',

        },

        [theme.breakpoints.down('sm')]: {
            padding: '2px calc(0.2vw + 0.2vh) 2px calc(0.2vh + 0.2vh)',

        },

        [theme.breakpoints.down('sm')]: {
            fontSize: 'calc(2.5px + 0.4vw + 0.9vh)',
            padding: '1px 10px 1px 5px',

        }
    },

    tableHeader: {
        // position: "sticky",
        // top: 0,
        // left: 0,
        // width: "100%",
        // zIndex: 99999,
        // background: "white"
    },

    tableCellHead: {

        [theme.breakpoints.down('xl')]: {
            padding: '2px calc(40px - 1vw) 2px 10px',

        },

        [theme.breakpoints.down('md')]: {
            padding: '2px calc(20px - 1vw) 2px 10px',

        },

        [theme.breakpoints.down('sm')]: {
            padding: '2px calc(0.2vw + 0.2vh) 2px calc(0.2vh + 0.2vh)'

        },

        color: '#A1A1A1',

        fontSize: 'calc(0.75vh + 0.4vw )'
    },

    pagination: {
        [theme.breakpoints.down('sm')]: {
            padding: '0px 2px 0px 2px',

        },
    },

    move: {

        [theme.breakpoints.up('md')]: {
            alignItems: 'center',

        },

        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            alignItems: 'baseline'

        },
    },

    numAgents: {

        maxHeight: '15px',

        [theme.breakpoints.up('md')]: {
            margin: '0px 5px 0px 10px'
        },

        [theme.breakpoints.down('md')]: {
            margin: '0px 5px 0px 0px'

        },
    },

    numAgentsDay: {

        maxHeight: '15px',
        [theme.breakpoints.up('md')]: {
            margin: '0px 10px 0px 5px'
        },

        [theme.breakpoints.down('md')]: {
            margin: '0px 10px 0px 5px'

        },


    },

    numAgentsLegend: {
        maxHeight: '15px',

        [theme.breakpoints.up('md')]: {
            margin: '0px 20px 0px 0px'
        },

        [theme.breakpoints.down('md')]: {
            margin: 0

        },
    },

    desc: {

        [theme.breakpoints.down('lg')]: {

            textAlign: 'left'
        },
    },

    selector: {
        marginLeft: 10,
        [theme.breakpoints.down('md')]: {
            marginTop: 10,
        }
    },


    sort: {

        [theme.breakpoints.down('md')]: {

            maxWidth: 'calc(9px + 0.5vh + 0.5vw)',
            maxHeight: 'calc(9px + 0.5vh + 0.5vw)'

        },

        [theme.breakpoints.up('md')]: {

            maxWidth: '22px',
            maxHeight: '22px'

        },

        [theme.breakpoints.up('lg')]: {

            maxWidth: '28px',
            maxHeight: '28px'

        },

    },

    Action: {

        [theme.breakpoints.down('md')]: {

            maxWidth: 'calc(9px + 0.5vh + 0.5vw)',
            maxHeight: 'calc(9px + 0.5vh + 0.5vw)'

        },

        [theme.breakpoints.up('md')]: {

            maxWidth: '25px',
            maxHeight: '25px'

        },
    },

    actionButton: {
        boxShadow: 'none',
        backgroundColor: "#E0F4F741"
    },

    icon: {
        marginRight: '5px',
        color: 'disabled',
        [theme.breakpoints.down('md')]: {
            maxWidth: 'calc(3px + 1vh + 0.9vw )',
            maxHeight: 'calc(3px + 1vh + 0.9vw )'
        },

    },

    searchDiv: {
        height: 'calc(15px + 0.5vw + 0.5vh)',

        [theme.breakpoints.up('md')]: {
            padding: "5px 0px 5px 15px"
        },

        [theme.breakpoints.down('md')]: {
            padding: '3px 0px 3px 10px'
        },
    },

    headingRow: {
        [theme.breakpoints.down('md')]: {
            height: 'calc(1vh + 3vw)'
        }
    },

    bodyRow: {

        "&:hover": {
            backgroundColor: "#EBF8FA !important"
        },

        [theme.breakpoints.up('lg')]: {
            height: '74px'
        }
    },

    head: {

        [theme.breakpoints.up('md')]: {
            margin: "0px 0 50px 0"
        },

        [theme.breakpoints.up('sm')]: {
            margin: "0px 0px 0px 0px"
        },

        [theme.breakpoints.down('sm')]: {
            margin: "8px 0px 8px 0px"
        }
    },

    marketPosition: {
        [theme.breakpoints.down('sm')]: {
            fontSize: 'calc(2.5px + 0.4vw + 0.9vh)'
        }
    },

    inputLabels: {
        [theme.breakpoints.down('sm')]: {
            fontSize: 'calc(1px + 0.8vh + 1vw)'
        }
    },

    noData: {

        fontWeight: 'bold',
        color: 'rgba(0, 0, 0, 0.47)'
        ,
        [theme.breakpoints.up('md')]: {
            fontSize: '34px'
        },

        [theme.breakpoints.down('md')]: {
            fontSize: 'calc(16px + 0.9vh + 0.7vw)'
        }
    },

    toggleContainer: {
        backgroundColor: 'transparent',
        height: 56,
        padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        margin: `${theme.spacing.unit}px 0`,
        background: theme.palette.background.default,

        [theme.breakpoints.down('sm')]: {
            padding: '8px 0px 8px 0px',
            margin: "2px 0px",
            height: '0px'

        }
    },


});

const columns = [
    {
        id: 'name',
        label: 'Scenarios',
        align: 'left',
    },
    {
        id: 'product',
        label: 'Product',
        align: 'right',

    },
    {
        id: 'price',
        label: 'Price',
        align: 'right',
        format: value => value.toLocaleString(),
    },
    // {
    //     id: 'promoSpend',
    //     label: 'Promotional Spend',
    //     align: 'right',
    //     format: value => value.toLocaleString()
    // },
    {
        id: 'marketPosition',
        label: 'Market Position',
        align: 'right',
        format: value => value.toLocaleString()
    },

    {
        id: 'action',
        label: 'Actions',
        align: 'center',

    },

];




const image = {
    'explore': 'explore2.svg',
    'Coffee': "coffee-mug.svg",
    'delete': 'delete.svg',
    'Fruit': 'juice.svg',
    'play': 'path.svg',
    'view': 'eye.svg',
    'Carbonation': 'soft-drink.svg',
    'Tea': 'tea.svg',
    'Milk': 'milk.svg',
    'Water': 'water.svg'
}


class FilterTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            iconColor: 'disabled',
            searchTerm: '',
            selectedScenario: "Search Scenarios",
            product: "All",
            sortKey: "createdAt",
            sortOrder: "aesc",
            page: 0,
            rowsPerPage: 10,
            filtered: []
        }
    }

    keyPress(event) {
        if (event.which === 13 /* Enter */) {
            event.preventDefault();
        }
    }

    handleChangePage = (event, newPage) => {
        this.setState({
            page: newPage
        })
    }

    handleChangeRowsPerPage = (event) => {

        this.setState({
            rowsPerPage: +event.target.value,
            page: 0
        })
    }

    kFormatter(num) {
        if (num >= 1000000000) {
            return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
        }
        if (num >= 1000000) {
            return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
        }
        if (num >= 1000) {
            return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
        }
        return num;
    }

    componentDidMount() {
        this.setState({
            filtered: this.props.items
        })

    }

    componentDidUpdate = prevProps => {
        if (this.props.items !== prevProps.items) {
            this.setState({
                filtered: this.props.items
            })

            this.filterData(undefined, undefined, undefined, this.props.items, undefined)

        }
    }


    //Needs improvement ------> when filtering is present, if any entry is deleted, the filter rule fails and all elements are shown
    // Changes to be made ------> Currently, handle change is only being triggered on change, it should constantly read what data is present in the search bar
    // Edge situations ------->  Initialy, the placeholder is Search Scenario, that time handle change should not be triggered
    handleChangeSearch(e) {

        this.setState({
            searchTerm: e.target.value
        })

        this.filterData(e.target.value, undefined, undefined, undefined, undefined)
    }


    handleChangeSortKey = name => event => {

        this.setState({
            [name]: event.target.value
        })

        this.filterData(undefined, event.target.value, undefined, undefined, undefined);

    }

    handleChangeProduct = name => event => {

        this.setState({
            [name]: event.target.value
        })

        this.filterData(undefined, undefined, event.target.value, undefined, undefined)

    }

    handleSortOrder = (event, val) => {

        this.setState({
            sortOrder: val
        })

        this.filterData(undefined, undefined, undefined, undefined, val)
    }




    filterData(searchTerm = this.state.searchTerm, sortKey = this.state.sortKey, productSelected = this.state.product, data = this.props.items, sortOrder = this.state.sortOrder) {

        if (data.length > 0) {

            // Variable to hold initial version of list
            let currentList = []

            //Variable to hold filtered list before updating state
            let newList = []
            // 1. First filtering for search term

            //If searchbar has content
            if (searchTerm !== " ") {
                // Assign input data to current list variable

                currentList = data

                // Use filter to decide which items from the current list should be pushed to the new list based on search term

                newList = currentList.filter(item => {
                    // Change names to lower case

                    let scenarioName = item.name.toLowerCase()

                    //Check if it matches search term in lowercase, if so add the item to new list


                    let filter = searchTerm.toLowerCase()

                    return scenarioName.includes(filter)

                })

            } else {
                // if search bar is empty, set new list to origin data values

                newList = data
            }

            // 1. Filter based on product selected

            if (productSelected !== 'All') {
                newList = newList.filter(item => item.product === productSelected)
            }

            // 2. Sorting data based on sortKey and order

            if (sortOrder === 'aesc') {
                if (sortKey !== "None") {

                    if (sortKey === "timeDuration") {
                        newList = newList.sort(function (a, b) {

                            return (a.n_ticks - b.n_ticks)
                        })

                    } else if (sortKey === 'createdAt') {
                        newList = newList.sort(function (a, b) {
                            let crDateA = new Date(a.createdAt)
                            let crDateB = new Date(b.createdAt)
                            return (
                                crDateA - crDateB
                            )
                        })
                    }
                    else if (sortKey === "marketPosition") {
                        newList = newList.sort(function (b, a) { return a[sortKey] - b[sortKey] })
                    }
                    else {
                        newList = newList.sort(function (a, b) { return a[sortKey] - b[sortKey] })
                    }
                }
            }

            else if (sortOrder === 'desc') {
                if (sortKey !== "None") {

                    if (sortKey === "timeDuration") {
                        newList = newList.sort(function (a, b) {

                            return (b.n_ticks - a.n_ticks)
                        })

                    } else if (sortKey === 'createdAt') {
                        newList = newList.sort(function (a, b) {
                            let crDateA = new Date(a.createdAt)
                            let crDateB = new Date(b.createdAt)
                            return (
                                crDateB - crDateA
                            )
                        })
                    } else if (sortKey === "marketPosition") {
                        newList = newList.sort(function (b, a) { return b[sortKey] - a[sortKey] })
                    } else {
                        newList = newList.sort(function (a, b) { return b[sortKey] - a[sortKey] })
                    }
                }
            }

            // After passing the conditions, set filtered array to the new list

            this.setState({
                filtered: newList
            })
        }

        else {
            this.setState({
                filtered: []
            })
        }



    }

    titleCase = str => {

        str = str.toLowerCase().split(' ');

        let final = [];

        for (let word of str) {
            final.push(word.charAt(0).toUpperCase() + word.slice(1));
        }

        return final.join(' ')

    }

    triggerCreateScenario() {
        this.setState({
            showDialog: false
        })

        this.props.switchPannel(1)
    }

    render() {
        return (
            <div>
                <Grid container direction="row" justify="space-between" style={{ width: '100%', display: 'flex', alignItems: 'center' }} className={this.props.classes.head} >
                    <Grid item sx={3}>
                        <div className={this.props.classes.searchDiv} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', backgroundColor: "#F6F6F6", borderRadius: "20px" }}>
                            <SearchIcon className={this.props.classes.icon} />
                            <form style={{ display: 'flex', flexWrap: 'wrap', fontStyle: 'italic' }} noValidate >
                                <StyledInputBase
                                    placeholder={this.state.selectedScenario}

                                    inputProps={{ 'aria-label': 'naked' }}
                                    onKeyPress={this.keyPress}
                                    onChange={this.handleChangeSearch.bind(this)}
                                    style={{ color: '#989898' }}
                                />
                            </ form>
                            {/* <CloseIcon style={{ marginRight: '10px', maxWidth: 'calc(0.5vw + 0.9vh)', color: '#b7b5b5' }} onClick={this.clearSearch.bind(this)} /> */}
                        </div>

                    </Grid>
                    <Grid sx={6} item>


                    </Grid>
                    <Grid sx={6} item>
                        <Grid container direction="row" alignItems="center">
                            <Grid className={this.props.classes.selector} sx={3} item>
                                <FormControl style={{ display: 'flex', flexWrap: 'wrap' }}  >
                                    <InputLabel className={this.props.classes.inputLabels} shrink htmlFor="product-native-label-placeholder">
                                        Product
                                     </InputLabel>
                                    <StyledProductSelect

                                        value={this.state.product}
                                        onChange={this.handleChangeProduct('product')}
                                        autoWidth={true}
                                        inpumiddletProps={{
                                            name: 'product',
                                            id: 'product-native-label-placeholder',
                                        }}
                                    >
                                        <StyledMenuProd value="All" >All</StyledMenuProd>
                                        <StyledMenuProd value='Tea'>Tea</StyledMenuProd>
                                        <StyledMenuProd value='Juice'>Juice</StyledMenuProd>
                                        <StyledMenuProd value='Soft_EnergyDrinks'>Soft Drink</StyledMenuProd>
                                        <StyledMenuProd value='Coffee'>Coffee</StyledMenuProd>
                                        <StyledMenuProd value='Water'>Water</StyledMenuProd>

                                    </StyledProductSelect>

                                </FormControl>
                            </Grid>
                            <Grid className={this.props.classes.selector} sx={4} item>
                                <FormControl style={{ display: 'flex', flexWrap: 'wrap' }}  >
                                    <InputLabel className={this.props.classes.inputLabels} shrink htmlFor="sortBy-native-label-placeholder">
                                        Sort By:
                                    </InputLabel>
                                    <StyledSortSelect
                                        displayEmpty={false}
                                        value={this.state.sortKey}
                                        onChange={this.handleChangeSortKey('sortKey')}
                                        autoWidth={true}
                                        inputProps={{
                                            name: 'sortKey',
                                            id: 'sortBy-native-label-placeholder',
                                        }}
                                    >
                                        <StyledMenuSort value='createdAt'>Date Created</StyledMenuSort>
                                        <StyledMenuSort value="price">Price</StyledMenuSort>
                                        {/* <StyledMenuSort value='promoSpend'>Promotion</StyledMenuSort> */}
                                        <StyledMenuSort value='marketPosition'>Market Position</StyledMenuSort>
                                        <StyledMenuSort value='numAgents'>Number of Agents</StyledMenuSort>
                                        <StyledMenuSort value='timeDuration'>Time Duration</StyledMenuSort>
                                    </StyledSortSelect>

                                </FormControl>
                            </Grid>
                            <Grid className={this.props.classes.selector} sx={3} item>
                                <div className={this.props.classes.toggleContainer} >
                                    <ToggleButtonGroup
                                        value={this.state.sortOrder}
                                        exclusive
                                        onChange={this.handleSortOrder}
                                        style={{ display: 'flex' }}
                                    >
                                        <StyledToggleButton value='desc' >
                                            <img className={this.props.classes.sort} src="sort1.svg" alt={"Sort in descending order"} ></img>
                                        </StyledToggleButton>
                                        <StyledToggleButton value='aesc'>
                                            <img className={this.props.classes.sort} src="sort2.svg" alt={"Sort in ascending order"} ></img>
                                        </StyledToggleButton>
                                    </ToggleButtonGroup>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <div className={this.props.classes.root} >
                    <div className={this.props.classes.tableWrapper}>
                        <Table stickyHeader >
                            <TableHead className={this.props.classes.tableHeader}>
                                <TableRow className={this.props.classes.headingRow}>
                                    <TableCell
                                        className={this.props.classes.tableCellHead}
                                        key={columns.id}
                                        align="left"
                                        style={{ borderBottom: '2px solid #1f77b557' }}
                                    >
                                        <Grid container style={{ alignItems: 'center' }}>
                                            <Grid sx={4} style={{ marginRight: '10px' }} item>
                                                Scenarios ({this.state.filtered ? this.state.filtered.length : 0})
                                            </Grid>
                                            {/* <Grid item style={{ marginRight: '5px' }}> / </Grid> */}
                                            <Grid xs={2} item>
                                                <StyledButton2 onClick={this.triggerCreateScenario.bind(this)} >Add +</StyledButton2>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                    {columns.slice(1).map(column => (
                                        <TableCell
                                            className={this.props.classes.tableCellHead}
                                            key={columns.id}
                                            align="center"
                                            style={{ borderBottom: '2px solid #1f77b557' }}
                                        >
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody className={this.props.tableBody}>
                                {this.state.filtered && this.state.filtered.length > 0 ? this.state.filtered.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map(row => (
                                    <TableRow hover className={this.props.classes.bodyRow} style={{ fontWeight: 'bolder' }} role="checkbox" tabIndex={-1} key={row.scenarioId}>
                                        <TableCell className={this.props.classes.tableCell} key={columns.id} align={columns.align}>
                                            <div className={this.props.classes.move} style={{ display: 'flex', justifyContent: 'start' }}>
                                                <Tooltip title={row["name"]} placement="bottom-end" leaveDelay={5} >
                                                    <div className={"scenarioTitle"} style={{ fontWeight: '600px', fontSize: 'calc(1.2vh + .4vw)' }}>{row.name ? row.name : "Unnamed Scenario"}</div>
                                                </Tooltip>
                                                <Hidden xsDown>
                                                    <div style={{ display: 'flex' }}>
                                                        <div className={this.props.classes.numAgents} style={{ backgroundColor: '#F6F6F6', borderTopLeftRadius: 10, borderTopRightRadius: 10, borderBottomLeftRadius: 10, borderBottomRightRadius: 10, border: '0.5px solid rgba(161, 161, 161, 0.41)', fontStyle: 'italic', color: 'rgb(107, 107, 107)', fontSize: 'calc(0.45vh + 0.3vw)', padding: 'calc(0.4px + 0.1vh) calc(6px + 0.1vh)', textAlign: 'center' }}>
                                                            {row.numAgents ? this.kFormatter(row.numAgents) : 0}
                                                        </div>
                                                        <div className={this.props.classes.numAgentsDay} style={{ backgroundColor: '#F6F6F6', borderTopLeftRadius: 10, borderTopRightRadius: 10, borderBottomLeftRadius: 10, borderBottomRightRadius: 10, border: '0.5px solid rgba(161, 161, 161, 0.41)', fontStyle: 'italic', color: 'rgb(107, 107, 107)', fontSize: 'calc(0.45vh + 0.3vw)', padding: 'calc(0.4px + 0.1vh) calc(6px + 0.1vh)', textAlign: 'center' }}>
                                                            {row.n_ticks * 1 / 24} Days
                                                    </div>
                                                    </div>
                                                    <div style={{ fontStyle: 'italic', fontWeight: 'lighter', color: '#344955ad', fontSize: 'calc(0.5vh + 0.4vw)' }}>
                                                        <div>{row.startTime ? new Date(new Date(row.startTime * 1000).setFullYear(2020)).toUTCString().slice(5, 11) : null} to {row.n_ticks ? new Date(new Date(row.startTime * 1000 + row.n_ticks * 60 * 60 * 1000).setFullYear(2020)).toUTCString().slice(5, 16) : null}
                                                        </div>
                                                    </div>
                                                </Hidden>
                                            </div>
                                            <Hidden mdDown >
                                                <div className={this.props.classes.desc} style={{ fontWeight: 'lighter', fontSize: 10, textAlign: 'justify', color: '#0000009c' }}>{row.description ? row.description : "Scenario description not given"}</div>
                                            </Hidden>
                                        </TableCell>
                                        <TableCell className={this.props.classes.tableCell} key={columns.id} align='center'>
                                            <StyledTooltip title={row["product"].toLowerCase()} placement="bottom-end" leaveDelay={5} >
                                                <div className={this.props.classes.productIcon} style={{ backgroundColor: "rgba(224, 244, 247, 0.5)", border: '3px solid white', borderRadius: '5px' }}>
                                                    <img className={this.props.classes.sort} src={image[row["product"]]} alt={row.product} ></img>
                                                </div>
                                            </StyledTooltip>
                                        </TableCell>
                                        <TableCell className={this.props.classes.info} key={columns.id} align='center' style={{ color: '#344955', }}>
                                            ${row.price ? row.price : 0}
                                        </TableCell>
                                        {/* <TableCell className={this.props.classes.info} key={columns.id} align='center' style={{ color: '#344955', }}>
                                            ${row.promoSpend ? this.kFormatter(row.promoSpend) : 0}
                                        </TableCell> */}
                                        <TableCell className={this.props.classes.tableCell} key={columns.id} align='center' style={{ alignItems: 'center' }}>
                                            <div className={this.props.classes.marketPosition}>#{row.marketPosition ? row.marketPosition : 0}</div>
                                            <Hidden xsDown>
                                                <div style={{ fontSize: 9 }}>of {row.numberOfCompetitors ? row.numberOfCompetitors : "#"}</div>
                                            </Hidden>
                                        </TableCell>
                                        <TableCell className={this.props.classes.tableCell} style={{ padding: '4px 5px 4px 5px' }} key={columns.id} align='center'>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <div>
                                                    <StyledButton onClick={() => this.props.openScenario(row.scenarioId)} disableRipple={true} className={this.props.classes.actionButton} variant="contained" disabled={false}>
                                                        <img className={this.props.classes.Action} src={image.explore} alt={"View simulation"}  ></img>
                                                    </StyledButton>

                                                    <StyledButton disableRipple={true} className={this.props.classes.actionButton} onClick={() => this.props.delete(row.scenarioId)} variant="contained" disabled={false}>
                                                        <img className={this.props.classes.Action} src={image.delete} alt={"Delete Scenario"} ></img>
                                                    </StyledButton>
                                                </div>
                                                <Hidden smDown>
                                                    <div style={{ fontStyle: 'italic', color: 'rgb(107, 107, 107)', fontSize: 'calc(0.45vh + 0.3vw)', marginTop: '1px' }}>
                                                        <div>Created on: {row.createdAt ? new Date(row.createdAt).toUTCString().slice(5, 16) : "--"}</div>
                                                        {/* <div>Created at: {row.createdAt ? new Date(row.createdAt).toTimeString().slice(0, 8) : "--"} hrs</div> */}
                                                    </div>
                                                </Hidden>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                )) : null}
                            </TableBody>
                        </Table>
                    </div>
                    <Hidden xsDown  >
                        <Grid container
                            justify='space-between'
                            alignItems='center'
                            style={{ paddingTop: 'calc(0.2vw + 0.5vh)', borderTop: '0.2px solid #80808096' }}
                        >
                            <Grid item xs={3} >
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }} >
                                    <div style={{ display: 'flex', marginRight: '10px' }}>
                                        <div className={this.props.classes.numAgentsL} style={{ color: 'rgb(107, 107, 107)', width: '0px', fontSize: 'calc(0.45vh + 0.3vw)', padding: 'calc(0.4px + 0.1vh) calc(6px + 0.1vh)', textAlign: 'right' }} >
                                            *
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <div className={this.props.classes.numAgentsL} style={{ backgroundColor: '#F6F6F6', borderTopLeftRadius: 10, borderTopRightRadius: 10, borderBottomLeftRadius: 10, borderBottomRightRadius: 10, border: '0.5px solid rgba(161, 161, 161, 0.41)', fontStyle: 'italic', color: 'rgb(107, 107, 107)', fontSize: 'calc(0.45vh + 0.3vw)', padding: 'calc(0.4px + 0.1vh) calc(6px + 0.1vh)', textAlign: 'center' }}>
                                                500K
                                        </div>
                                        </div>
                                    </div>
                                    <div style={{ fontStyle: 'italic', fontWeight: 'lighter', color: '#344955ad', fontSize: 'calc(0.5vh + 0.4vw)' }}>
                                        <div>Number of agents</div>
                                    </div>
                                </div>
                            </Grid>
                            <Grid xs={9} item>
                                {this.state.filtered && this.state.filtered.length > 5 ?

                                    <StyledTablePagination
                                        classname={this.props.classes.pagination}
                                        rowsPerPageOptions={[5, 10, 15]}
                                        component="div"
                                        count={this.state.filtered ? this.state.filtered.length : 0}
                                        rowsPerPage={this.state.rowsPerPage}
                                        page={this.state.page}
                                        backIconButtonProps={{
                                            'aria-label': 'previous page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'next page',
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    /> : null}
                            </Grid>
                        </Grid>
                    </Hidden>
                </div>
            </div>
        )
    }
}

FilterTable.propTypes = {
    classes: PropTypes.object
}


export default withStyles(styles)(FilterTable);
